/* eslint-disable max-len */
import {
  ReferenceSource,
  ReferenceStockTradingDataRequestDetail,
} from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/request/GetReferencesStockRequest';
import { FilterAndSort } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterAndSort';
import { FilterArray } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterArray';
import { FilterBy } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/FilterBy';
import { SortBy } from '@1po/1po-bff-fe-spec/generated/common/filter_and_sort/SortBy';
import {
  COMMAND_PROCESSING_RESPONSE,
  COMMAND_PROCESSING_RESPONSE_WITH_DATA,
  QUERY_ERROR_RESPONSE,
  QUERY_INVALID_RESPONSE,
} from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { UPDATE_OBSERVATIONS_URL, UPDATE_SETTINGS_URL } from '@1po/1po-bff-fe-spec/generated/estimate/EstimateURLs';
import { Origin } from '@1po/1po-bff-fe-spec/generated/estimate/request/AddCatalogReferencesToBasket';
import { MyStoreBundleItem } from '@1po/1po-bff-fe-spec/generated/estimate/request/AddFreeBundlesFromMyStore';
import { MyStoreReferenceItem } from '@1po/1po-bff-fe-spec/generated/estimate/request/AddReferenceFromAutocomplete';
import { LinkedReference } from '@1po/1po-bff-fe-spec/generated/estimate/request/AddReferenceFromCatalog';
import { AddVehicle } from '@1po/1po-bff-fe-spec/generated/estimate/request/AddVehicle';
import { ReferenceTradingDataRequestDetail } from '@1po/1po-bff-fe-spec/generated/estimate/request/GetReferenceTradingDataForB2BEstimateRequest';
import { FilterAndSortField } from '@1po/1po-bff-fe-spec/generated/estimate/request/model/FilterAndSortField';
import { AddReferenceByRefNumber } from '@1po/1po-bff-fe-spec/generated/estimate/response/AddReferenceByRefNumber';
import { AutocompleteSearchBundlesResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/AutocompleteSearchBundlesResponse';
import { AutocompleteSearchReferencesResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/AutocompleteSearchReferencesResponse';
import { CheckoutB2BEstimateOrderResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/CheckoutB2BEstimateOrderResponse';
import { EstimateDmsOrderNumbers } from '@1po/1po-bff-fe-spec/generated/estimate/response/EstimateDmsOrderNumbers';
import { EstimateUnavailableResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/EstimateUnavailableResponse';
import { GetEstimate } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetEstimate';
import { GetEstimateHistory } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetEstimateHistory';
import { GetReferencesDiscountsForB2BEstimateResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetReferencesDiscountsForB2BEstimateResponse';
import { GetReferencesPriceForB2BEstimateResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetReferencesPriceForB2BEstimateResponse';
import { GetReferencesStocksForB2BEstimateResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetReferencesStocksForB2BEstimateResponse';
import { GetSettings } from '@1po/1po-bff-fe-spec/generated/estimate/response/GetSettings';
import { RemovedB2BEstimateReferencesDiscountsResponse } from '@1po/1po-bff-fe-spec/generated/estimate/response/RemovedB2BEstimateReferencesDiscountsResponse';
import { call, put, putResolve, takeEvery, takeLatest } from '@redux-saga/core/effects';
import { SagaIterator } from 'redux-saga';
import { v4 as uuidv4 } from 'uuid';
import { ROUTER_ESTIMATE } from 'app/AppRouter';
import { redirect, RootState } from 'app/AppStore';
import { getBasketHasTractionBatteryForVehicle } from 'domains/basket/Basket.store';
import { getLastVehicleDetail, setLastSearchedVehicleKey } from 'domains/catalog/Catalog.store';
import {
  getSelectedEasyBasketLaborTimesData,
  getSelectedEasyBasketOperation,
  getSelectedEasyBasketReferenceNumbers,
  getSelectedEasyBasketReferencesData,
} from 'domains/easyBasket/EasyBasket.store';
import {
  fillFromMaintenancePlan,
  sendAddBundlesAutocomplete,
  sendAddBundlesFromMyStore,
  sendAddCatalogLaborTime,
  sendAddCatalogReference,
  sendAddCatalogReferencesToBasket,
  sendAddCustomItem,
  sendAddDmsOrderNumber,
  sendAddEasyBasketOperationRequest,
  sendAddLaborTimeByCode,
  sendAddReferenceAutocomplete,
  sendAddReferenceByReferenceNumber,
  sendAddReferenceNumber,
  sendAddTire,
  sendAddTireByReferenceNumber,
  sendAddVehicle,
  sendB2BEstimateToClientRequest,
  sendCancelDeletionRequest,
  sendCheckoutB2BRequest,
  sendClearItems,
  sendDeleteEstimateRequest,
  sendEstimateToDMS,
  sendGetEstimateById,
  sendGetHistory,
  sendGetReferencesPriceRequest,
  sendGetReferencesStocksRequest,
  sendGetRepairOrderRequest,
  sendGetSettings,
  sendQueryAutocompleteBundlesRequest,
  sendQueryAutocompleteReferencesRequest,
  sendRemoveItem,
  sendUpdateB2BCounterParties,
  sendUpdateBundleOrRecycling,
  sendUpdateClientContact,
  sendUpdateLaborTime,
  sendUpdateObservations,
  sendUpdateOperation,
  sendUpdateOperationLaborTime,
  sendUpdateOperationReference,
  sendUpdateReference,
  sendUpdateSettings,
  sendUpdateVehicle,
} from 'domains/estimate/Estimate.api';
import { getOperationEstimateRequestData } from 'domains/estimate/Estimate.mapper';
import * as actions from 'domains/estimate/Estimate.store';
import {
  addReferenceForValidation,
  createNewEstimate,
  getCatalogOperationReferences,
  getCatalogReferences,
  getCurrentEstimate,
  getCurrentEstimateId,
  getEasyBasketEstimateCreationStatus,
  getEstimateById,
  getEstimateHistoryCursor,
  getEstimateHistorySearch,
  getEstimateObservationSaveKey,
  getEstimateSettings,
  getEstimateSettingsSaveKey,
  getEstimateVehicleKey,
  getHasTractionBatteryInEstimate,
  getReferences,
  removeB2BEstimateReferencesDiscounts,
  removeReferenceForValidation,
  resetEstimateHistory,
  resetSellerBuyerInfo,
  setB2BEstimateReferencesDiscountsData,
  setB2BEstimateReferencesPriceData,
  setB2BEstimateReferencesPriceNoDataStatus,
  setB2BEstimateReferencesStockData,
  setB2BEstimateReferencesStockNoDataStatus,
  setBundleFulltextAutocomplete,
  setBundleLastAutocompleteKey,
  setCurrentEstimateId,
  setDmsOrderNumbers,
  setEasyBasketEstimateCreationStatus,
  setEstimateDataStatus,
  setEstimateHidden,
  setEstimateHistoryResponse,
  setEstimateHistorySearchStatus,
  setEstimateRemoved,
  setEstimateResponse,
  setHistoryEstimate,
  setOrderEstimateStatus,
  setReferenceFulltextAutocomplete,
  setReferenceLastAutocompleteKey,
  setSettings,
} from 'domains/estimate/Estimate.store';
import { EstimateIdParam, RequestReference } from 'domains/estimate/Estimate.types';
import { getUserGarageWorkshopId } from 'domains/garage/Garage.store';
import { clearCheckoutStatus, setCheckoutStatus } from 'domains/order/Order.store';

import {
  DHReferenceLocal,
  getDHReferences,
  getLoadedPrices,
  getPricesMap,
  NON_MKTP,
  ReferencePriceType,
} from 'domains/references';

import { getTradingProfile, getUserContext, getUserRights, hideDMSErrorPopup, UserRole } from 'domains/user';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import type { WsResponseWithRequestTraceId } from 'domains/webSockets/WebSocket.types';
import { notifyTop } from 'UI/Notification/notification';
import { AppTranslation, DONE, FOUND, getData, getSearchData, hasData, LOADING, NO_DATA, sagaGuard } from 'utils';
import { select } from 'utils/domainStore';
import logger from 'utils/remoteLogger';
import {
  getTractionBatteryBlockedMessage,
  getTractionBatteryOrderStatus,
  hasUserAnyRight,
  isSingleUnitOrderRestrictedFamily,
  TRACTION_BATTERY_FAMILY_CODES,
} from 'utils/rights';

const getEstimateTractionBatterySingleUnitMessage = (): string =>
  AppTranslation.t(
    'cart.action.add_reference.traction_battery_single_unit_tooltip',
    'This part is restricted to single-unit orders.',
  );

export function* fetchEstimateByIdResponse(action: WsResponse<GetEstimate>): SagaIterator {
  const payload = action.payload;
  const { estimate } = payload;
  const { estimateId, clientContact } = estimate;
  const tradingProfile = yield* select(getTradingProfile);

  const storedEstimate = getData(yield* select((state: RootState) => getEstimateById(state, estimateId)));
  const buyerTresorCode = clientContact.tresorCode ?? tradingProfile?.buyerId;
  const sellerTresorCode = clientContact.sellerTresorCode ?? tradingProfile?.sellerId;
  const userContext = yield* select(getUserContext);

  if (estimate.estimateType === 'B2B' && buyerTresorCode !== undefined && sellerTresorCode !== undefined) {
    const catalogReferences = estimate.referenceSubsection.references.filter((ref) => !ref.isCustom);

    const referencesWithoutPrice = catalogReferences
      .filter((ref) => !storedEstimate?.prices?.has(ref.referenceNumber))
      .map((ref) => {
        return {
          referenceNumber: ref.referenceNumber,
          commercialFamily: ref.commercialFamily ?? '',
          origin: ref.origin,
          supplierCode: ref.supplierCode,
          referenceSource: ref.referenceSource,
        } as ReferenceTradingDataRequestDetail;
      });

    const referencesWithoutStock = catalogReferences
      .filter((ref) => {
        const currStock = storedEstimate?.stockInfo?.get(ref.referenceNumber);
        const sellerNumber = ref.sellerNumber ?? NON_MKTP;

        return (
          currStock === undefined ||
          currStock?.data?.get(sellerNumber ?? NON_MKTP)?.confirmedQuantity !== Number(ref.quantity)
        );
      })
      .map((ref) => {
        return {
          referenceNumber: ref.referenceNumber,
          type: ref.referenceType === 'TIRE' ? 'TIRE' : 'STANDARD',
          quantity: Number(ref.quantity),
          origin: ref.origin,
          supplierCode: ref.supplierCode,
          referenceSource: ref.referenceSource,
        } as ReferenceStockTradingDataRequestDetail;
      });

    if (referencesWithoutPrice.length > 0) {
      yield put(
        setB2BEstimateReferencesPriceNoDataStatus({
          estimateId,
          buyerTresorCode,
          sellerTresorCode,
          referenceNumbers: referencesWithoutPrice.map((r) => r.referenceNumber),
          status: LOADING,
        }),
      );
      yield put(sendGetReferencesPriceRequest(estimateId, buyerTresorCode, sellerTresorCode, referencesWithoutPrice));
    }

    if (referencesWithoutStock.length > 0) {
      yield put(
        setB2BEstimateReferencesStockNoDataStatus({
          estimateId,
          buyerTresorCode,
          sellerTresorCode,
          referenceNumbers: referencesWithoutStock.map((r) => r.referenceNumber),
          status: LOADING,
        }),
      );
      yield put(
        sendGetReferencesStocksRequest(
          estimateId,
          buyerTresorCode,
          sellerTresorCode,
          referencesWithoutStock,
          userContext,
        ),
      );
    }
  }
  yield put(setEstimateResponse(payload));
  yield put(setHistoryEstimate(payload));
}

export function* fetchDeleteEstimateByIdResponse(action: WsResponse<string>): SagaIterator {
  const estimateId = action.payload;

  yield call(clearRemovedEstimateState, estimateId);
}

export function* fetchEstimateUnavailableResponse(action: WsResponse<EstimateUnavailableResponse>): SagaIterator {
  const { estimateId, reason } = action.payload;

  if (reason === 'UNAVAILABLE') {
    yield call(clearRemovedEstimateState, estimateId);
    yield call(
      notifyTop,
      'error',
      AppTranslation.t(
        'estimate.unavailable',
        'This estimate is no longer available. It may have been deleted or expired.',
      ),
    );
    return;
  }

  yield call(
    notifyTop,
    'error',
    AppTranslation.t('estimate.creation_failed', 'The estimate could not be created. Please try again.'),
  );
}

function* clearRemovedEstimateState(estimateId: string): SagaIterator {
  const currentEstimateId = yield* select(getCurrentEstimateId);
  yield put(setEstimateRemoved({ estimateId }));

  if (currentEstimateId === estimateId) {
    yield put(createNewEstimate({ vehicle: undefined }));
    yield put(setLastSearchedVehicleKey(undefined));
  }
}

export function* fetchHideEstimateByIdResponse(action: WsResponse<string>): SagaIterator {
  const estimateId = action.payload;
  yield put(setEstimateHidden({ estimateId, isHidden: true }));
}

export function* fetchShowEstimateByIdResponse(action: WsResponse<string>): SagaIterator {
  const estimateId = action.payload;
  yield put(setEstimateHidden({ estimateId, isHidden: false }));
}

export function* fetchEstimateCreatedResponse(action: WsResponse<string>): SagaIterator {
  const estimateId = action.payload;

  yield put(resetEstimateHistory());
  yield put(actions.fetchEstimateHistoryRequest());
  yield put(actions.fetchEstimateByIdRequest(estimateId));
  yield put(setCurrentEstimateId(estimateId));
}

export function* fetchEasybasketAddedToEstimateResponse(action: WsResponse<string>): SagaIterator {
  const estimateId = action.payload;
  const easybasketCreationStatus = yield* select(getEasyBasketEstimateCreationStatus);

  if (easybasketCreationStatus?.estimateId === estimateId) {
    yield put(setEasyBasketEstimateCreationStatus({ estimateId, status: DONE }));
    const urlParams = new URLSearchParams(globalThis.location.search);
    urlParams.set(EstimateIdParam, estimateId);
    yield call(redirect, `${ROUTER_ESTIMATE}?${urlParams}`);
  }
}

export function* fetchEstimateHistoryRequest(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const cursor = yield* select(getEstimateHistoryCursor);
  const search = yield* select(getEstimateHistorySearch);

  if (!tradingProfile?.buyerId) {
    return;
  }

  let orFilter = undefined;
  if (search) {
    orFilter = new FilterArray<FilterAndSortField>('OR', [
      new FilterBy<FilterAndSortField>('VIN', search, 'CONTAINS'),
      new FilterBy<FilterAndSortField>('VRN', search, 'CONTAINS'),
      new FilterBy<FilterAndSortField>('SEQUENCE_NUMBER', search, 'CONTAINS'),
      new FilterBy<FilterAndSortField>('FULL_NAME', search, 'CONTAINS'),
      new FilterBy<FilterAndSortField>('RRF_CODE', search, 'CONTAINS'),
      new FilterBy<FilterAndSortField>('CREATOR_IPN', search, 'CONTAINS'),
      new FilterBy<FilterAndSortField>('REPAIR_ORDER_NUMBER', search, 'CONTAINS'),
    ]);
  }
  const filterAndSort: FilterAndSort<FilterAndSortField> = {
    filter: orFilter,
    sorts: [new SortBy('SEQUENCE_NUMBER', 'DESC')],
    cursor,
  };

  yield put(setEstimateHistorySearchStatus(LOADING));
  yield put(sendGetHistory({ filterAndSort }));
}

export function* fetchEstimateByIdRequest({
  payload,
}: ReturnType<typeof actions.fetchEstimateByIdRequest>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = payload;

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const existingEstimate = yield* select((state: RootState) => getEstimateById(state, estimateId));
  if (existingEstimate === undefined) {
    yield put(setEstimateDataStatus({ estimateId, status: LOADING }));
  }
  yield put(sendGetEstimateById({ estimateId }));
}

export function* fetchEstimateHistoryResponse(action: WsResponse<GetEstimateHistory>): SagaIterator {
  yield put(setEstimateHistoryResponse(action.payload));
}

export function* addCatalogLaborTime({ payload }: ReturnType<typeof actions.addCatalogLaborTime>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);

  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendAddCatalogLaborTime({
      estimateId,
      vehicleDetail,
      ...payload,
    }),
  );
}

export function* addBundleFromMyStore({ payload }: ReturnType<typeof actions.addBundleFromMyStore>): SagaIterator {
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);
  const { bundles, quantity } = payload;

  const converted: MyStoreBundleItem[] = bundles.map((i) => ({
    id: i.id || '',
    code: i.code || '',
    designation: i.designation || '',
    price: i.price,
    quantity: quantity ?? 1,
  }));

  yield put(
    sendAddBundlesFromMyStore({
      estimateId,
      vehicleDetail,
      myStoreBundles: [...converted],
    }),
  );
}

export function* addBundleFromAutocomplete({
  payload,
}: ReturnType<typeof actions.addBundleFromAutocomplete>): SagaIterator {
  const estimateId = yield* select(getCurrentEstimateId);
  const { bundle, itemId } = payload;
  const converted: MyStoreBundleItem = {
    id: bundle.id || '',
    code: bundle.code || '',
    designation: bundle.designation || '',
    price: bundle.price,
  };
  yield put(
    sendAddBundlesAutocomplete({
      estimateId,
      itemId,
      bundle: converted,
    }),
  );
}

export function* addReferenceFromAutocomplete({
  payload,
}: ReturnType<typeof actions.addReferenceFromAutocomplete>): SagaIterator {
  const estimateId = yield* select(getCurrentEstimateId);
  const { reference, itemId } = payload;
  const converted: MyStoreReferenceItem = {
    id: reference.referenceId || '',
    reference: reference.referenceNumber || '',
    designation: reference.designation || '',
    clientPriceVatExcluded: reference.clientPriceVatExcluded,
    garagePriceVatExcluded: reference.garagePriceVatExcluded,
  };
  yield put(
    sendAddReferenceAutocomplete({
      reference: converted,
      estimateId,
      itemId,
    }),
  );
}

function mapLinkedReference(
  reference: RequestReference,
  linkedRef: DHReferenceLocal,
  linkedRefPrices: { prices: NO_DATA | ReferencePriceType; reference: string }[],
) {
  const ratio =
    reference.linkedReferences?.find((ref) => ref.referenceNumber === linkedRef.referenceNumber)?.ratio ?? 1;
  const price = linkedRefPrices.find((refPrice) => refPrice.reference === linkedRef.referenceNumber)?.prices;
  const unitPrice =
    hasData(price) && price.clientView?.recommendedPriceVatExcluded
      ? price.clientView.recommendedPriceVatExcluded?.toString()
      : '';
  const priceVatExcluded =
    hasData(price) && price.clientView?.recommendedPriceVatExcluded
      ? price.clientView.recommendedPriceVatExcluded?.toString()
      : '';
  const garagePrice =
    hasData(price) && price.garageView?.vatExcludedPrice ? price.garageView.vatExcludedPrice?.toString() : '';
  const vatPercentage = hasData(price) && price.garageView?.vatPercentage ? price.garageView.vatPercentage : 20;
  const discountRate = hasData(price) ? price.garageView?.discountRate : '';
  return {
    referenceNumber: linkedRef.referenceNumber,
    designation: linkedRef.name,
    catalogSource: 'DATAHUB',
    quantity: ratio,
    isCompatible: linkedRef.isApplicableToCurrentVehicle ?? false,
    unitPrice,
    priceVatExcluded,
    vatPercentage,
    garagePrice,
    discountRate,
    ratio,
  } as LinkedReference;
}

/**
 * Validate if a traction battery or single-unit restricted item can be added to the estimate.
 * Returns true if allowed; returns false and notifies user if blocked.
 * Should be called before any addCatalogReference, addCatalogTire, or similar operations.
 */
function* validateTractionBatteryAddition(params: {
  estimateId: string;
  commercialFamily?: string;
  vin?: string;
  isCompatible?: boolean;
}): SagaIterator<boolean> {
  const { estimateId, commercialFamily, vin, isCompatible } = params;

  // Not a traction battery or restricted item—no validation needed
  if (!isSingleUnitOrderRestrictedFamily(commercialFamily)) {
    return true;
  }

  // Get user roles for order status check
  const userRoles = yield* select(getUserRights);
  const normalizedUserRoles = Array.isArray(userRoles) ? userRoles : undefined;

  // Check if the order is blocked for this user/VIN/compatibility
  const tractionBatteryOrderStatus = getTractionBatteryOrderStatus({
    vin,
    userRoles: normalizedUserRoles,
    familyCode: commercialFamily,
    isCompatible: isCompatible ?? false,
  });

  if (tractionBatteryOrderStatus.orderBlocked && tractionBatteryOrderStatus.orderBlockedMessage) {
    yield call(
      notifyTop,
      'error',
      AppTranslation.t(
        tractionBatteryOrderStatus.orderBlockedMessage.key,
        tractionBatteryOrderStatus.orderBlockedMessage.defaultMessage,
      ),
      null,
    );
    return false;
  }

  // Check single-unit restriction: only one traction battery per estimate
  const hasTractionBatteryInEstimate = yield* select((state: RootState) =>
    getHasTractionBatteryInEstimate(state, estimateId),
  );

  if (hasTractionBatteryInEstimate && isSingleUnitOrderRestrictedFamily(commercialFamily)) {
    yield call(notifyTop, 'info', getEstimateTractionBatterySingleUnitMessage(), null);
    return false;
  }

  return true;
}

export function* addCatalogReference({ payload }: ReturnType<typeof actions.addCatalogReference>): SagaIterator {
  const { reference } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const linkedRefNumbers = reference.linkedReferences?.map((linkedRef) => linkedRef.referenceNumber) ?? [];
  const linkedRefDetails = yield* select((state: RootState) =>
    getDHReferences(state, {
      vehicleKey: estimateVehicleKey,
      referenceNumbers: linkedRefNumbers,
    }),
  );
  const linkedRefPrices = yield* select((state: RootState) => getLoadedPrices(state, linkedRefNumbers ?? []));

  const linkedReferencesWithRatio = linkedRefDetails.map((r) => mapLinkedReference(reference, r, linkedRefPrices));

  const referenceWithLinkedDetails = {
    ...reference,
    linkedReferences: linkedReferencesWithRatio.filter((linkedRef) => linkedRef.garagePrice),
  };

  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  // Validate traction battery restrictions before adding
  const isAllowed = yield call(validateTractionBatteryAddition, {
    estimateId,
    commercialFamily: reference.commercialFamily,
    vin: vehicleDetail?.vin,
    isCompatible: reference.isCompatible,
  });
  if (!isAllowed) {
    return;
  }

  yield put(
    sendAddCatalogReference({
      reference: referenceWithLinkedDetails,
      vehicleDetail,
      estimateId,
    }),
  );
}

export function* addCustomReference(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const itemId = uuidv4();

  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,

      itemType: 'REFERENCE',
    }),
  );
}

export function* addCustomOperationReference({
  payload,
}: ReturnType<typeof actions.addCustomOperationReference>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);
  const { operationId } = payload;

  if (!tradingProfile?.buyerId || !estimateId || !operationId) {
    return;
  }

  const itemId = uuidv4();

  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,
      operationId,

      itemType: 'OPERATION_REFERENCE',
    }),
  );
}

export function* addCustomOperationLaborTime({
  payload,
}: ReturnType<typeof actions.addCustomOperationLaborTime>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);
  const { operationId } = payload;

  if (!tradingProfile?.buyerId || !estimateId || !operationId) {
    return;
  }

  const itemId = uuidv4();

  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,
      operationId,

      itemType: 'OPERATION_LABOR_TIME',
    }),
  );
}

export function* addOperation(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const itemId = uuidv4();

  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,

      itemType: 'OPERATION',
    }),
  );
}

export function* addCustomLaborTime(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const itemId = uuidv4();

  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,

      itemType: 'LABOR_TIME',
    }),
  );
}

export function* addCustomBundleOrRecycling(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const itemId = uuidv4();
  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,

      itemType: 'FREE_BUNDLE',
    }),
  );
}

export function* addCatalogTire({ payload }: ReturnType<typeof actions.addCatalogTire>): SagaIterator {
  const { reference } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);
  const userContext = yield* select(getUserContext);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  // Validate traction battery restrictions before adding
  const isAllowed = yield call(validateTractionBatteryAddition, {
    estimateId,
    commercialFamily: reference.commercialFamily,
    vin: vehicleDetail?.vin,
    isCompatible: reference.isCompatible,
  });
  if (!isAllowed) {
    return;
  }

  yield put(
    sendAddTire({
      vehicleDetail,
      reference,
      estimateId,
      userContext,
    }),
  );
}

export function* addCustomTire(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const itemId = uuidv4();

  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,

      itemType: 'TIRE',
    }),
  );
}

export function* addOtherItem(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const itemId = uuidv4();

  yield put(
    sendAddCustomItem({
      vehicleDetail,
      itemId,
      estimateId,

      itemType: 'OTHER_ITEM',
    }),
  );
}

export function* updateReference({ payload }: ReturnType<typeof actions.updateReference>): SagaIterator {
  const { itemId, parentItemId, newValue, field } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }
  if (field === 'REFERENCE_NUMBER' && newValue.length >= 10) {
    yield put(
      actions.addCatalogReferenceByReferenceNumber({
        referenceNumber: newValue,
        searchType: 'CUSTOM_ITEM',
        itemType: 'STANDARD',
        itemId,
      }),
    );
    return;
  }

  yield put(
    sendUpdateReference({
      itemId,
      parentItemId,
      newValue,
      field,
      estimateId,
    }),
  );
}
export function* updateOperationReference({
  payload,
}: ReturnType<typeof actions.updateOperationReference>): SagaIterator {
  const { itemId, operationId, newValue, field } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendUpdateOperationReference({
      itemId,
      operationId,
      newValue,
      field,
      estimateId,
    }),
  );
}

export function* updateLaborTime({ payload }: ReturnType<typeof actions.updateLaborTime>): SagaIterator {
  const { itemId, newValue, field } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendUpdateLaborTime({
      itemId,
      newValue,
      field,
      estimateId,
    }),
  );
}

export function* updateOperationLaborTime({
  payload,
}: ReturnType<typeof actions.updateOperationLaborTime>): SagaIterator {
  const { itemId, operationId, newValue, field } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendUpdateOperationLaborTime({
      itemId,
      operationId,
      newValue,
      field,
      estimateId,
    }),
  );
}

export function* updateBundleOrRecycling({
  payload,
}: ReturnType<typeof actions.updateBundleOrRecycling>): SagaIterator {
  const { itemId, newValue, field } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendUpdateBundleOrRecycling({
      itemId,
      newValue,
      field,
      estimateId,
    }),
  );
}

export function* updateOperation({ payload }: ReturnType<typeof actions.updateOperation>): SagaIterator {
  const { itemId, newValue, field } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendUpdateOperation({
      itemId,
      newValue,
      field,
      estimateId,
    }),
  );
}

export function* removeReference({ payload }: ReturnType<typeof actions.removeReference>): SagaIterator {
  const { itemId, parentItemId } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId,
      parentItemId,
      estimateId,
      itemType: 'REFERENCE',
    }),
  );
}
export function* removeOperationReference({
  payload,
}: ReturnType<typeof actions.removeOperationReference>): SagaIterator {
  const { itemId, operationId } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId,
      operationId,
      estimateId,
      itemType: 'OPERATION_REFERENCE',
    }),
  );
}

export function* removeLaborTime({ payload }: ReturnType<typeof actions.removeLaborTime>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId: payload,
      itemType: 'LABOR_TIME',
      estimateId,
    }),
  );
}

export function* removeOperationLaborTime({
  payload,
}: ReturnType<typeof actions.removeOperationLaborTime>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  const { itemId, operationId } = payload;
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId,
      operationId,
      estimateId,
      itemType: 'OPERATION_LABOR_TIME',
    }),
  );
}

export function* removeTire({ payload }: ReturnType<typeof actions.removeTire>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId: payload,
      itemType: 'TIRE',
      estimateId,
    }),
  );
}

export function* removeOtherItem({ payload }: ReturnType<typeof actions.removeOtherItem>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId: payload,
      itemType: 'OTHER_ITEM',
      estimateId,
    }),
  );
}

export function* removeBundleOrRecycling({
  payload,
}: ReturnType<typeof actions.removeBundleOrRecycling>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId: payload,
      itemType: 'FREE_BUNDLE',
      estimateId,
    }),
  );
}

export function* removeOperation({ payload }: ReturnType<typeof actions.removeOperation>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendRemoveItem({
      itemId: payload,
      itemType: 'OPERATION',
      estimateId,
    }),
  );
}

export function* removeAllReferences(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }
  yield put(sendClearItems({ estimateId, itemType: 'REFERENCE' }));
}

export function* removeAllLaborTimes(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }
  yield put(sendClearItems({ estimateId, itemType: 'LABOR_TIME' }));
}

export function* removeAllBundlesOrRecycling(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }
  yield put(sendClearItems({ estimateId, itemType: 'FREE_BUNDLE' }));
}

export function* removeAllTires(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }
  yield put(sendClearItems({ estimateId, itemType: 'TIRE' }));
}

export function* removeAllOtherItems(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }
  yield put(sendClearItems({ estimateId, itemType: 'OTHER_ITEM' }));
}

export function* deleteEstimateRequest({ payload }: ReturnType<typeof actions.deleteEstimateRequest>): SagaIterator {
  const { estimateId } = payload;
  const tradingProfile = yield* select(getTradingProfile);
  const currentEstimateId = yield* select(getCurrentEstimateId);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendDeleteEstimateRequest({
      estimateId,
    }),
  );

  yield put(setEstimateHidden({ estimateId, isHidden: true }));

  if (currentEstimateId === estimateId) {
    yield put(createNewEstimate({ vehicle: undefined }));
    yield put(setLastSearchedVehicleKey(undefined));
  }
}

export function* cancelEstimateDeletionRequest({
  payload,
}: ReturnType<typeof actions.cancelEstimateDeletion>): SagaIterator {
  const { estimateId } = payload;
  const tradingProfile = yield* select(getTradingProfile);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  yield put(
    sendCancelDeletionRequest({
      estimateId,
    }),
  );

  yield put(setEstimateHidden({ estimateId, isHidden: false }));
}

export function* updateClient({ payload }: ReturnType<typeof actions.updateClient>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const estimateId = yield* select(getCurrentEstimateId);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }
  const { newValue, field } = payload;

  yield put(
    sendUpdateClientContact({
      originalVehicle: vehicleDetail,
      estimateId,
      newValue,
      field,
    }),
  );
}

export function* updateB2BCounterParties({
  payload,
}: ReturnType<typeof actions.updateB2BCounterParties>): SagaIterator {
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateData = getData(yield* select((state: RootState) => getEstimateById(state, estimateId)));
  const { buyerTresorCode, sellerTresorCode } = payload;
  const userContext = yield* select(getUserContext);
  const catalogReferences = estimateData?.referenceSubsection.references.filter((ref) => !ref.isCustom) ?? [];

  const referencesPriceRequest = catalogReferences.map((ref) => {
    return {
      referenceNumber: ref.referenceNumber,
      commercialFamily: ref.commercialFamily ?? '',
      origin: ref.origin,
      supplierCode: ref.supplierCode,
      referenceSource: ref.referenceSource,
    } as ReferenceTradingDataRequestDetail;
  });

  const referencesStockRequest = catalogReferences.map((ref) => {
    return {
      referenceNumber: ref.referenceNumber,
      type: ref.referenceType === 'TIRE' ? 'TIRE' : 'STANDARD',
      quantity: Number(ref.quantity),
      origin: ref.origin,
      supplierCode: ref.supplierCode,
      referenceSource: ref.referenceSource,
    } as ReferenceStockTradingDataRequestDetail;
  });

  yield put(resetSellerBuyerInfo(estimateId));
  yield put(
    sendUpdateB2BCounterParties({
      estimateId,
      sellerTresorCode,
      buyerTresorCode,
    }),
  );

  if (referencesPriceRequest.length > 0) {
    yield put(
      setB2BEstimateReferencesPriceNoDataStatus({
        estimateId,
        buyerTresorCode,
        sellerTresorCode,
        referenceNumbers: referencesPriceRequest.map((r) => r.referenceNumber),
        status: LOADING,
      }),
    );
    yield put(sendGetReferencesPriceRequest(estimateId, buyerTresorCode, sellerTresorCode, referencesPriceRequest));
  }
  if (referencesStockRequest.length > 0) {
    yield put(
      setB2BEstimateReferencesStockNoDataStatus({
        estimateId,
        buyerTresorCode,
        sellerTresorCode,
        referenceNumbers: referencesStockRequest.map((r) => r.referenceNumber),
        status: LOADING,
      }),
    );
    yield put(
      sendGetReferencesStocksRequest(
        estimateId,
        buyerTresorCode,
        sellerTresorCode,
        referencesStockRequest,
        userContext,
      ),
    );
  }
}

export function* updateObservations({ payload }: ReturnType<typeof actions.updateObservations>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const { estimateId, newValue } = payload;
  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const request = sendUpdateObservations({
    estimateId,
    originalVehicle: vehicleDetail,
    newValue,
  });
  yield put(
    actions.registerTextSaveRequest({
      requestId: request.traceId,
      saveKey: getEstimateObservationSaveKey(estimateId),
      value: newValue,
    }),
  );
  yield put(request);
}

export function* addVehicle(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !vehicleDetail || !estimateId) {
    return;
  }

  const request: AddVehicle = {
    estimateId,

    vehicleDetail,
  };

  yield put(sendAddVehicle(request));
}

export function* updateVehicle({ payload }: ReturnType<typeof actions.updateVehicle>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const estimateId = yield* select(getCurrentEstimateId);
  if (!tradingProfile?.buyerId || !vehicleDetail || !estimateId) {
    return;
  }
  const { newValue, field } = payload;
  yield put(
    sendUpdateVehicle({
      estimateId,
      newValue,
      field,
      originalVehicle: vehicleDetail,
    }),
  );
}

export function* updateSettings({ payload }: ReturnType<typeof actions.updateSettings>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.buyerId) {
    return;
  }

  const request = sendUpdateSettings(payload);
  yield put(
    actions.registerTextSaveRequest({
      requestId: request.traceId,
      saveKey: getEstimateSettingsSaveKey(payload.field, payload.filters),
      value: payload.newValue,
    }),
  );
  yield put(request);
}

export function* handleTextSaveResponse(action: WsResponseWithRequestTraceId): SagaIterator {
  if (action.requestUrl !== UPDATE_OBSERVATIONS_URL && action.requestUrl !== UPDATE_SETTINGS_URL) {
    return;
  }
  if (!action.requestTraceId) {
    yield put(logger.warn(`Ignoring text save response without request trace ID for URL ${action.requestUrl}`));
    return;
  }
  let successful = false;
  if (action.type === COMMAND_PROCESSING_RESPONSE) {
    successful = action.payload === true;
  } else if (action.type === COMMAND_PROCESSING_RESPONSE_WITH_DATA) {
    successful = isSuccessfulCommandResponse(action.payload);
  }
  yield put(actions.completeTextSaveRequest({ requestId: action.requestTraceId, successful }));
}

function isSuccessfulCommandResponse(payload: unknown): boolean {
  if (typeof payload !== 'object' || payload === null || !('result' in payload)) {
    return false;
  }
  return payload.result === 'SUCCESS' || payload.result === 'NO_CHANGE';
}

export function* addCatalogReferenceByReferenceNumber({
  payload,
}: ReturnType<typeof actions.addCatalogReferenceByReferenceNumber>): SagaIterator {
  const userContext = yield* select(getUserContext);
  const estimateId = yield* select(getCurrentEstimateId);

  if (!estimateId) {
    return;
  }

  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);
  const { referenceNumber, itemId, itemType, searchType } = payload;

  // For reference numbers added by number, we cannot determine commercialFamily client-side,
  // but the backend will validate traction battery restrictions server-side.

  yield putResolve(
    addReferenceForValidation({
      userContext,
      referenceNumber,
      vehicleDetail,
      estimateId,
      itemId,
      itemType,
      searchType,
    }),
  );
  yield put(
    sendAddReferenceByReferenceNumber({
      userContext,
      referenceNumber,
      vehicleDetail,
      estimateId,
      itemId,
      itemType,
      searchType,
    }),
  );
}

export function* addReferenceNumber({ payload }: ReturnType<typeof actions.addReferenceNumber>): SagaIterator {
  const userContext = yield* select(getUserContext);
  const estimateId = yield* select(getCurrentEstimateId);

  if (!estimateId) {
    return;
  }

  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  const vehicleDetail = estimateVehicleKey === undefined ? undefined : yield* select(getLastVehicleDetail);
  const { referenceNumber, itemId } = payload;

  yield put(
    sendAddReferenceNumber({
      userContext,
      referenceNumber,
      vehicleDetail,
      estimateId,
      itemId,
    }),
  );
}

export function* addCatalogTireByReferenceNumber({
  payload,
}: ReturnType<typeof actions.addCatalogTireByReferenceNumber>): SagaIterator {
  const userContext = yield* select(getUserContext);
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const estimateId = yield* select(getCurrentEstimateId);

  if (!estimateId) {
    return;
  }

  const { referenceNumber, itemId, itemType, searchType } = payload;

  if (searchType === 'CUSTOM_ITEM') {
    yield putResolve(
      addReferenceForValidation({
        userContext,
        referenceNumber,
        vehicleDetail,
        estimateId,
        itemId,
        itemType,
        searchType,
      }),
    );
  }

  // For tire reference numbers, we cannot determine commercialFamily client-side,
  // but the backend will validate traction battery restrictions server-side.
  // Frontend validation will still occur if the reference is already in state with known family.

  yield put(
    sendAddTireByReferenceNumber({
      userContext,
      referenceNumber,
      vehicleDetail,
      estimateId,
      itemId,
      itemType,
      searchType,
    }),
  );
}

export function* removeKnownReferenceValidation({
  payload,
}: ReturnType<typeof actions.removeKnownReferenceValidation>): SagaIterator {
  yield putResolve(removeReferenceForValidation(payload));
}

export function* addCatalogLaborTimeByCode({
  payload,
}: ReturnType<typeof actions.addCatalogLaborTimeByCode>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const userContext = yield* select(getUserContext);
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const estimateId = yield* select(getCurrentEstimateId);

  if (!tradingProfile?.buyerId || !vehicleDetail || !estimateId) {
    return;
  }

  const laborTimeCode = payload;
  yield put(
    sendAddLaborTimeByCode({
      userContext,
      laborTimeCode,
      vehicleDetail,
      estimateId,
    }),
  );
}

export function* fetchSettingsRequest(): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  if (!tradingProfile?.buyerId) {
    return;
  }
  yield put(sendGetSettings());
}

export function* fetchSettingsResponse(action: WsResponse<GetSettings>): SagaIterator {
  const { estimateSettings } = action.payload;
  yield put(setSettings(estimateSettings));
}

export function* fetchDmsOrderNumbersResponse(action: WsResponse<EstimateDmsOrderNumbers>): SagaIterator {
  yield put(setDmsOrderNumbers(action.payload));
}

export function* addDmsOrderNumberRequest({
  payload,
}: ReturnType<typeof actions.addDmsOrderNumberRequest>): SagaIterator {
  yield put(sendAddDmsOrderNumber(payload));
}

type BasketCatalogReference = {
  quantity: number;
  referenceNumber: string;
  referenceSource?: ReferenceSource;
  origin?: Origin;
  supplierCode?: string;
  sellerNumber?: string;
};

type BasketMainReference = BasketCatalogReference & {
  linkedReferences?: BasketCatalogReference[];
};

function getCatalogReferencesCount(
  references: BasketMainReference[],
  operationReferences: BasketCatalogReference[],
  linkedReferences: BasketCatalogReference[],
): number {
  return references.length + operationReferences.length + linkedReferences.length;
}

function mergeCatalogReferences(
  references: BasketMainReference[],
  linkedReferences: BasketCatalogReference[],
  operationReferences: BasketCatalogReference[],
): BasketCatalogReference[] {
  const mergedByReference = new Map<string, BasketCatalogReference>();

  [...references, ...linkedReferences, ...operationReferences].forEach((reference) => {
    const existing = mergedByReference.get(reference.referenceNumber);
    if (!existing) {
      mergedByReference.set(reference.referenceNumber, {
        quantity: reference.quantity,
        referenceNumber: reference.referenceNumber,
        referenceSource: reference.referenceSource,
        origin: reference.origin,
        supplierCode: reference.supplierCode,
        sellerNumber: reference.sellerNumber,
      });
      return;
    }

    mergedByReference.set(reference.referenceNumber, {
      quantity: existing.quantity + reference.quantity,
      referenceNumber: existing.referenceNumber,
      referenceSource: existing.referenceSource ?? reference.referenceSource,
      origin: existing.origin ?? reference.origin,
      supplierCode: existing.supplierCode ?? reference.supplierCode,
      sellerNumber: existing.sellerNumber ?? reference.sellerNumber,
    });
  });

  return Array.from(mergedByReference.values());
}

function mapReferenceDetail(ref: BasketCatalogReference) {
  return {
    quantity: ref.quantity,
    referenceNumber: ref.referenceNumber,
    referenceSource: ref.referenceSource ?? 'STANDARD',
    origin: ref.origin,
    supplierCode: ref.supplierCode,
    sellerNumber: ref.sellerNumber,
  };
}

export function* addCatalogReferencesToBasket(): SagaIterator {
  const userContext = yield* select(getUserContext);
  const currentVehicleDetail = yield* select(getLastVehicleDetail);
  const estimateId = yield* select(getCurrentEstimateId);
  const estimateVehicleKey = yield* select((state: RootState) => getEstimateVehicleKey(state, estimateId));
  if (!estimateId) {
    return;
  }

  const hasTractionBattery = yield* select((state: RootState) => getHasTractionBatteryInEstimate(state, estimateId));
  if (hasTractionBattery) {
    const userRoles = yield* select(getUserRights);
    const normalizedUserRoles = Array.isArray(userRoles) ? userRoles : undefined;
    const vin = estimateVehicleKey ? currentVehicleDetail?.vin : undefined;
    const tractionBatteryOrderStatus = getTractionBatteryOrderStatus({
      userRoles: normalizedUserRoles,
      familyCode: TRACTION_BATTERY_FAMILY_CODES[0],
      vin,
    });
    if (tractionBatteryOrderStatus.orderBlocked && tractionBatteryOrderStatus.orderBlockedMessage) {
      yield call(
        notifyTop,
        'error',
        AppTranslation.t(
          tractionBatteryOrderStatus.orderBlockedMessage.key,
          tractionBatteryOrderStatus.orderBlockedMessage.defaultMessage,
        ),
        null,
      );
      return;
    }

    // Check if basket already has a traction battery for this vehicle
    const basketHasTractionBattery = yield* select((state: RootState) =>
      getBasketHasTractionBatteryForVehicle(state, estimateVehicleKey),
    );
    if (basketHasTractionBattery) {
      yield call(
        notifyTop,
        'error',
        AppTranslation.t(
          'cart.action.add_reference.traction_battery_already_in_basket',
          "This part already exists in the basket and it's restricted to single-unit orders",
        ),
        null,
      );
      return;
    }
  }

  const rawReferences = yield* select((state: RootState) => getCatalogReferences(state, estimateId));
  const references: BasketMainReference[] = rawReferences.map((ref) => ({
    quantity: Number(ref.quantity),
    referenceNumber: ref.referenceNumber,
    referenceSource: ref.referenceSource,
    origin: ref.origin,
    supplierCode: ref.supplierCode,
    sellerNumber: ref.sellerNumber,
    linkedReferences: ref.linkedReferences?.map((lr) => ({
      quantity: lr.quantity,
      referenceNumber: lr.referenceNumber,
      referenceSource: lr.referenceSource,
      origin: lr.origin,
      supplierCode: lr.supplierCode,
    })),
  }));
  const linkedReferences = references.flatMap((ref) => ref.linkedReferences ?? []);
  const rawOperationReferences = yield* select((state: RootState) => getCatalogOperationReferences(state, estimateId));
  const operationReferences: BasketCatalogReference[] = rawOperationReferences.map((ref) => ({
    quantity: Number(ref.quantity),
    referenceNumber: ref.referenceNumber,
    referenceSource: ref.referenceSource,
    origin: ref.origin,
    supplierCode: ref.supplierCode,
    sellerNumber: ref.sellerNumber,
  }));

  if (getCatalogReferencesCount(references, operationReferences, linkedReferences) === 0) {
    return;
  }

  const referenceDetails = mergeCatalogReferences(references, linkedReferences, operationReferences).map(
    mapReferenceDetail,
  );

  // Note: addCatalogReferencesToBasket sends all items to the backend basket.
  // Backend will validate single-unit traction battery restrictions at basket checkout time.
  yield call(
    notifyTop,
    'info',
    AppTranslation.t('estimate.action.transfer_to_cart.pending', 'References are being added to your cart'),
  );
  yield put(
    sendAddCatalogReferencesToBasket({
      userContext,
      referenceDetails,
      vehicleDetail: estimateVehicleKey ? currentVehicleDetail : undefined,
    }),
  );
}

function getKnownReferenceMissingPriceMessage(): string {
  return AppTranslation.t(
    'cart.action.add_reference.missing_price',
    'Price currently unavailable, please try again later.',
  );
}

function getKnownReferenceUnknownMessage(): string {
  return AppTranslation.t('catalog.reference.error.unknown_reference', 'Unknown reference');
}

function getKnownReferenceVinNonCompliantMessage(): string {
  return AppTranslation.t(
    'cart.action.add_reference.traction_battery_vin_non_compliant',
    'This traction battery is not compatible with your vehicle',
  );
}

function getKnownReferenceZeReadyRequiredMessage(): string {
  const message = getTractionBatteryBlockedMessage('ze_ready_required');
  return message ? AppTranslation.t(message.key, message.defaultMessage) : getKnownReferenceMissingPriceMessage();
}

function* getNotAllowedKnownReferenceMessage(currentEstimateId: string): SagaIterator<string> {
  const userRoles = yield* select(getUserRights);
  const normalizedUserRoles = Array.isArray(userRoles) ? userRoles : [];
  const isR3OrR3Motrio = hasUserAnyRight(['R3' as UserRole, 'R3_MOTRIO' as UserRole], normalizedUserRoles);

  if (isR3OrR3Motrio) {
    const r3Message = getTractionBatteryBlockedMessage('r3_restricted');
    return r3Message
      ? AppTranslation.t(r3Message.key, r3Message.defaultMessage)
      : getKnownReferenceMissingPriceMessage();
  }

  const hasTractionBatteryInEstimate = yield* select((state: RootState) =>
    getHasTractionBatteryInEstimate(state, currentEstimateId),
  );
  if (hasTractionBatteryInEstimate) {
    return getEstimateTractionBatterySingleUnitMessage();
  }

  const vinRequiredMessage = getTractionBatteryBlockedMessage('vin_required');
  return vinRequiredMessage
    ? AppTranslation.t(vinRequiredMessage.key, vinRequiredMessage.defaultMessage)
    : getKnownReferenceMissingPriceMessage();
}

function* getKnownReferenceErrorMessage(result: string, currentEstimateId: string): SagaIterator<string> {
  if (result === 'UNKNOWN_REFERENCE') {
    return getKnownReferenceUnknownMessage();
  }
  if (result === 'VIN_NON_COMPLIANT') {
    return getKnownReferenceVinNonCompliantMessage();
  }
  if (result === 'ZE_READY_REQUIRED') {
    return getKnownReferenceZeReadyRequiredMessage();
  }
  if (result === 'NOT_ALLOWED') {
    return yield call(getNotAllowedKnownReferenceMessage, currentEstimateId);
  }
  return getKnownReferenceMissingPriceMessage();
}

function* findKnownReferenceItem(
  itemType: string,
  currentEstimateId: string,
  referenceNumber: string,
): SagaIterator<{ ref?: { commercialFamily?: string }; tire?: unknown }> {
  const references = yield* select((state: RootState) => getReferences(state, currentEstimateId));

  if (itemType === 'STANDARD') {
    return { ref: references.find((r) => r.referenceNumber === referenceNumber) };
  }

  if (itemType === 'TIRE') {
    return { tire: references.find((r) => r.referenceNumber === referenceNumber && r.referenceType === 'TIRE') };
  }

  return {};
}

function* notifyKnownReferenceListed(referenceNumber: string): SagaIterator {
  const msg = AppTranslation.t(
    'estimate.action.result.reference_listed',
    'This reference is already listed in your estimate',
  );
  const decs = AppTranslation.t(
    'estimate.action.result.reference_listed.description',
    '1 unit has been added to reference {{ referenceNumber }}',
    {
      referenceNumber,
    },
  );
  yield call(notifyTop, 'info', msg, decs);
}

export function* addKnowReferenceByRefNumberResponse(action: WsResponse<AddReferenceByRefNumber>): SagaIterator {
  const { estimateId, result, referenceNumber, itemType } = action.payload;
  const currentEstimateId = yield* select(getCurrentEstimateId);

  if (currentEstimateId !== estimateId) {
    return;
  }

  if (result !== 'OK') {
    const notificationMessage = yield call(getKnownReferenceErrorMessage, result, currentEstimateId);
    yield call(notifyTop, 'error', notificationMessage, null);
    return;
  }

  const { ref, tire } = yield call(findKnownReferenceItem, itemType, currentEstimateId, referenceNumber);

  if (!ref && !tire) {
    return;
  }

  if (ref && isSingleUnitOrderRestrictedFamily(ref.commercialFamily)) {
    yield call(notifyTop, 'info', getEstimateTractionBatterySingleUnitMessage(), null);
    return;
  }

  yield call(notifyKnownReferenceListed, referenceNumber);
}

export function* addTireByRefNumberResponse(action: WsResponse<AddReferenceByRefNumber>): SagaIterator {
  const { estimateId, result, referenceNumber } = action.payload;
  const currentEstimateId = yield* select(getCurrentEstimateId);

  if (currentEstimateId === estimateId) {
    if (result !== 'OK') {
      let notificationMessage = AppTranslation.t(
        'cart.action.add_reference.missing_price',
        'Price currently unavailable, please try again later.',
      );

      if (result === 'UNKNOWN_REFERENCE') {
        notificationMessage = AppTranslation.t('catalog.reference.error.unknown_reference', 'Unknown reference');
      } else if (result === 'VIN_NON_COMPLIANT') {
        notificationMessage = AppTranslation.t(
          'cart.action.add_reference.traction_battery_vin_non_compliant',
          'This traction battery is not compatible with your vehicle',
        );
      } else if (result === 'ZE_READY_REQUIRED') {
        const zeMessage = getTractionBatteryBlockedMessage('ze_ready_required');
        notificationMessage = zeMessage
          ? AppTranslation.t(zeMessage.key, zeMessage.defaultMessage)
          : notificationMessage;
      } else {
        // Keep missing-price as the default message for all other non-OK results.
      }

      yield call(notifyTop, 'error', notificationMessage, null);
    } else {
      const msg = AppTranslation.t(
        'estimate.action.result.tire_reference_listed.description',
        'Tire reference has been added to the tire section of the estimate',
        {
          referenceNumber,
        },
      );
      yield call(notifyTop, 'success', msg);
    }
  }
}

export function* sendEstimateToDMSResponse(): SagaIterator {
  yield call(
    notifyTop,
    'success',
    AppTranslation.t('estimate.dms.export.success', 'The estimation has been successfully sent to your DMS'),
    null,
  );
}

export function* fillEstimateFromMaintenancePlan({
  payload,
}: ReturnType<typeof actions.fillEstimateFromMaintenancePlan>): SagaIterator {
  const tradingProfile = yield* select(getTradingProfile);
  const estimateId = yield* select(getCurrentEstimateId);

  if (!tradingProfile?.buyerId || !estimateId) {
    return;
  }

  const { vehicleDetail, laborTimes, references } = payload;
  if (!vehicleDetail) {
    return;
  }

  yield put(
    fillFromMaintenancePlan({
      references,
      laborTimes,
      vehicleDetail,
      estimateId,
    }),
  );
}

export function* createEstimateFromDMSRequest({
  payload,
}: ReturnType<typeof actions.createEstimateFromDMSRequest>): SagaIterator {
  const { orderNumber } = payload;
  const userContext = yield* select(getUserContext);
  const workshopId = yield* select(getUserGarageWorkshopId);

  if (!workshopId) {
    return;
  }

  yield put(hideDMSErrorPopup());
  yield put(sendGetRepairOrderRequest({ userContext, workshopId, orderNumber }));
}

export function* sendEstimateToDMSRequest(): SagaIterator {
  const estimateId = yield* select(getCurrentEstimateId);
  const workshopId = yield* select(getUserGarageWorkshopId);

  if (!workshopId || !estimateId) {
    return;
  }

  yield put(hideDMSErrorPopup());
  yield put(sendEstimateToDMS({ estimateId, workshopId }));
}

export function* sendAutocompleteBundlesRequest({
  payload,
}: ReturnType<typeof actions.sendAutocompleteBundlesRequest>): SagaIterator {
  yield put(
    setBundleLastAutocompleteKey({ searchCode: payload.queryCode, searchDescription: payload.queryDescription }),
  );
  yield put(
    sendQueryAutocompleteBundlesRequest({
      searchQueryCode: payload.queryCode,
      searchQueryDesignation: payload.queryDescription,
    }),
  );
}

export function* sendAutocompleteBundlesResponse(action: WsResponse<AutocompleteSearchBundlesResponse>): SagaIterator {
  yield put(setBundleFulltextAutocomplete(action.payload));
}

export function* sendAutocompleteReferencesRequest({
  payload,
}: ReturnType<typeof actions.sendAutocompleteReferencesRequest>): SagaIterator {
  yield put(
    setReferenceLastAutocompleteKey({
      searchCode: payload.queryReference,
      searchDescription: payload.queryDescription,
    }),
  );
  yield put(
    sendQueryAutocompleteReferencesRequest({
      searchQueryReference: payload.queryReference,
      searchQueryDesignation: payload.queryDescription,
    }),
  );
}

export function* sendAutocompleteReferencesResponse(
  action: WsResponse<AutocompleteSearchReferencesResponse>,
): SagaIterator {
  yield put(setReferenceFulltextAutocomplete(action.payload));
}

export function* checkoutB2BEstimateRequest({
  payload,
}: ReturnType<typeof actions.checkoutB2BEstimateRequest>): SagaIterator {
  const { estimateId, checkoutItems, deliveryType, paymentClientCode, instruction } = payload;
  const userContext = yield* select(getUserContext);
  const estimate = getData(yield* select((state: RootState) => getEstimateById(state, estimateId)));
  if (!estimate) {
    return;
  }

  yield put(clearCheckoutStatus());
  yield put(setOrderEstimateStatus({ estimateId, status: LOADING }));
  yield put(
    sendCheckoutB2BRequest({
      estimateId,
      userContext,
      deliveryType,
      paymentClientCode,
      instruction,
      mktpDeliveryMode: estimate.estimateOrderItemDetails.mktpDeliveryMode,
      itemDetails: checkoutItems,
    }),
  );
}

export function* checkoutB2BEstimateResponse(action: WsResponse<CheckoutB2BEstimateOrderResponse>): SagaIterator {
  const payload = action.payload;
  const { estimateId, placedOrders, failedOrders, ordersOverallStatus } = payload;
  yield put(setOrderEstimateStatus({ estimateId, status: FOUND }));
  yield put(
    setCheckoutStatus({
      placedOrders,
      failedOrders,
      ordersOverallStatus,
    }),
  );
}

export function* sendB2BEstimateToClientHistorySaga(): SagaIterator {
  const estimateId = yield* select(getCurrentEstimateId);
  const newClientEstimateId = uuidv4();
  if (!estimateId) {
    return;
  }

  yield put(sendB2BEstimateToClientRequest({ estimateId, newClientEstimateId }));
}

export function* fetchB2BReferencesPriceResponseSaga(
  action: WsResponse<GetReferencesPriceForB2BEstimateResponse>,
): SagaIterator {
  yield put(setB2BEstimateReferencesPriceData({ ...action.payload }));
}

export function* fetchB2BReferencesStockResponseSaga(
  action: WsResponse<GetReferencesStocksForB2BEstimateResponse>,
): SagaIterator {
  yield put(setB2BEstimateReferencesStockData({ ...action.payload }));
}

export function* fetchB2BReferencesDiscountsResponseSaga(
  action: WsResponse<GetReferencesDiscountsForB2BEstimateResponse>,
): SagaIterator {
  yield put(setB2BEstimateReferencesDiscountsData({ ...action.payload }));
}

export function* b2BReferencesDiscountsRemovedSaga(
  action: WsResponse<RemovedB2BEstimateReferencesDiscountsResponse>,
): SagaIterator {
  yield put(removeB2BEstimateReferencesDiscounts({ ...action.payload }));
}

export function* sendB2BEstimateToClientHistoryResponse(action: WsResponse<string>): SagaIterator {
  const id = action.payload;
  if (id.length > 0) {
    yield call(
      notifyTop,
      'success',
      AppTranslation.t(
        'estimate.actions.result.estimate_sent_to_history',
        'Estimation has been sent to the garage history',
      ),
    );
  }
}

export function* addEasyBasketOperationToEstimate(): SagaIterator {
  const vehicleDetail = yield* select(getLastVehicleDetail);
  const currentEstimate = yield* select(getCurrentEstimate);
  const selectedReferencesData = yield* select(getSelectedEasyBasketReferencesData);
  const selectedLaborTimesData = yield* select(getSelectedEasyBasketLaborTimesData);
  const referenceNumbers = yield* select(getSelectedEasyBasketReferenceNumbers);
  const selectedOperation = yield* select(getSelectedEasyBasketOperation);
  const estimateSettings = yield* select(getEstimateSettings);
  const prices = yield* select((state: RootState) => getPricesMap(state, referenceNumbers));

  const request = getOperationEstimateRequestData(
    getSearchData(selectedOperation)?.designation ?? '',
    selectedReferencesData,
    selectedLaborTimesData,
    prices,
    estimateSettings,
    vehicleDetail,
    currentEstimate,
  );

  yield put(setEasyBasketEstimateCreationStatus({ estimateId: request.estimateId, status: LOADING }));
  yield put(sendAddEasyBasketOperationRequest(request));
}

export function* EstimateSagas(): SagaIterator {
  yield takeEvery(COMMAND_PROCESSING_RESPONSE, sagaGuard(handleTextSaveResponse));
  yield takeEvery(COMMAND_PROCESSING_RESPONSE_WITH_DATA, sagaGuard(handleTextSaveResponse));
  yield takeEvery(QUERY_ERROR_RESPONSE, sagaGuard(handleTextSaveResponse));
  yield takeEvery(QUERY_INVALID_RESPONSE, sagaGuard(handleTextSaveResponse));
  yield takeEvery(actions.fetchEstimateByIdRequest.type, sagaGuard(fetchEstimateByIdRequest));
  yield takeEvery(actions.fetchEstimateByIdResponse.type, sagaGuard(fetchEstimateByIdResponse));
  yield takeEvery(actions.fetchDeleteEstimateByIdResponse.type, sagaGuard(fetchDeleteEstimateByIdResponse));
  yield takeEvery(actions.fetchHideEstimateByIdResponse.type, sagaGuard(fetchHideEstimateByIdResponse));
  yield takeEvery(actions.fetchShowEstimateByIdResponse.type, sagaGuard(fetchShowEstimateByIdResponse));
  yield takeEvery(actions.fetchEstimateCreatedResponse.type, sagaGuard(fetchEstimateCreatedResponse));
  yield takeEvery(actions.fetchEstimateUnavailableResponse.type, sagaGuard(fetchEstimateUnavailableResponse));
  yield takeEvery(
    actions.fetchEasybasketAddedToEstimateResponse.type,
    sagaGuard(fetchEasybasketAddedToEstimateResponse),
  );
  yield takeEvery(actions.fetchEstimateHistoryRequest.type, sagaGuard(fetchEstimateHistoryRequest));
  yield takeEvery(actions.fetchEstimateHistoryResponse.type, sagaGuard(fetchEstimateHistoryResponse));

  yield takeEvery(actions.addCatalogLaborTime.type, sagaGuard(addCatalogLaborTime));
  yield takeEvery(actions.addCatalogReference.type, sagaGuard(addCatalogReference));
  yield takeEvery(actions.addReferenceNumber.type, sagaGuard(addReferenceNumber));
  yield takeEvery(actions.addCatalogTire.type, sagaGuard(addCatalogTire));
  yield takeLatest(actions.addCatalogReferenceByReferenceNumber.type, sagaGuard(addCatalogReferenceByReferenceNumber));
  yield takeLatest(actions.addCatalogTireByReferenceNumber.type, sagaGuard(addCatalogTireByReferenceNumber));
  yield takeLatest(actions.addCatalogLaborTimeByCode.type, sagaGuard(addCatalogLaborTimeByCode));
  yield takeEvery(actions.addCustomReference.type, sagaGuard(addCustomReference));
  yield takeEvery(actions.addCustomOperationReference.type, sagaGuard(addCustomOperationReference));
  yield takeEvery(actions.addCustomOperationLaborTime.type, sagaGuard(addCustomOperationLaborTime));
  yield takeEvery(actions.addOperation.type, sagaGuard(addOperation));
  yield takeEvery(actions.addEasyBasketOperationToEstimate.type, sagaGuard(addEasyBasketOperationToEstimate));
  yield takeEvery(actions.addCustomLaborTime.type, sagaGuard(addCustomLaborTime));
  yield takeEvery(actions.addCustomBundleOrRecycling.type, sagaGuard(addCustomBundleOrRecycling));
  yield takeEvery(actions.addCustomTire.type, sagaGuard(addCustomTire));
  yield takeEvery(actions.addOtherItem.type, sagaGuard(addOtherItem));

  yield takeLatest(actions.updateReference.type, sagaGuard(updateReference));
  yield takeLatest(actions.updateOperationReference.type, sagaGuard(updateOperationReference));
  yield takeLatest(actions.updateOperationLaborTime.type, sagaGuard(updateOperationLaborTime));
  yield takeLatest(actions.updateLaborTime.type, sagaGuard(updateLaborTime));
  yield takeLatest(actions.updateOperation.type, sagaGuard(updateOperation));
  yield takeLatest(actions.updateBundleOrRecycling.type, sagaGuard(updateBundleOrRecycling));
  // Keep in-flight saves alive so each response can be matched by its trace ID.
  yield takeEvery(actions.updateSettings.type, sagaGuard(updateSettings));
  yield takeLatest(actions.addBundleFromMyStore.type, sagaGuard(addBundleFromMyStore));
  yield takeLatest(actions.addBundleFromAutocomplete.type, sagaGuard(addBundleFromAutocomplete));
  yield takeLatest(actions.addReferenceFromAutocomplete.type, sagaGuard(addReferenceFromAutocomplete));

  yield takeEvery(actions.removeReference.type, sagaGuard(removeReference));
  yield takeEvery(actions.removeOperationReference.type, sagaGuard(removeOperationReference));
  yield takeEvery(actions.removeLaborTime.type, sagaGuard(removeLaborTime));
  yield takeEvery(actions.removeOperationLaborTime.type, sagaGuard(removeOperationLaborTime));
  yield takeEvery(actions.removeBundleOrRecycling.type, sagaGuard(removeBundleOrRecycling));
  yield takeEvery(actions.removeOperation.type, sagaGuard(removeOperation));
  yield takeEvery(actions.removeTire.type, sagaGuard(removeTire));
  yield takeEvery(actions.removeOtherItem.type, sagaGuard(removeOtherItem));

  yield takeLatest(actions.removeAllReferences.type, sagaGuard(removeAllReferences));
  yield takeLatest(actions.removeAllLaborTimes.type, sagaGuard(removeAllLaborTimes));
  yield takeLatest(actions.removeAllBundlesOrRecycling.type, sagaGuard(removeAllBundlesOrRecycling));
  yield takeLatest(actions.removeAllTires.type, sagaGuard(removeAllTires));
  yield takeLatest(actions.removeAllOtherItems.type, sagaGuard(removeAllOtherItems));
  yield takeLatest(actions.deleteEstimateRequest.type, sagaGuard(deleteEstimateRequest));
  yield takeLatest(actions.cancelEstimateDeletion.type, sagaGuard(cancelEstimateDeletionRequest));

  yield takeLatest(actions.addVehicle.type, sagaGuard(addVehicle));
  yield takeLatest(actions.updateVehicle.type, sagaGuard(updateVehicle));
  yield takeLatest(actions.updateClient.type, sagaGuard(updateClient));
  // Observation saves use the same per-request acknowledgement flow.
  yield takeEvery(actions.updateObservations.type, sagaGuard(updateObservations));

  yield takeLatest(actions.removeKnownReferenceValidation.type, sagaGuard(removeKnownReferenceValidation));

  yield takeLatest(actions.fetchSettingsRequest.type, sagaGuard(fetchSettingsRequest));
  yield takeLatest(actions.fetchSettingsResponse.type, sagaGuard(fetchSettingsResponse));

  yield takeLatest(actions.addCatalogReferencesToBasket.type, sagaGuard(addCatalogReferencesToBasket));
  yield takeLatest(actions.addKnowReferenceByRefNumberResponse.type, sagaGuard(addKnowReferenceByRefNumberResponse));
  yield takeLatest(actions.addTireByRefNumberResponse.type, sagaGuard(addTireByRefNumberResponse));

  yield takeLatest(actions.createEstimateFromDMSRequest.type, sagaGuard(createEstimateFromDMSRequest));
  yield takeLatest(actions.sendEstimateToDMSRequest.type, sagaGuard(sendEstimateToDMSRequest));
  yield takeLatest(actions.sendEstimateToDMSResponse.type, sagaGuard(sendEstimateToDMSResponse));
  yield takeLatest(actions.fetchDmsOrderNumbersResponse.type, sagaGuard(fetchDmsOrderNumbersResponse));
  yield takeLatest(actions.addDmsOrderNumberRequest.type, sagaGuard(addDmsOrderNumberRequest));

  yield takeLatest(actions.fillEstimateFromMaintenancePlan.type, sagaGuard(fillEstimateFromMaintenancePlan));

  yield takeLatest(actions.sendB2BEstimateToClientHistoryRequest.type, sagaGuard(sendB2BEstimateToClientHistorySaga));
  yield takeLatest(
    actions.sendB2BEstimateToClientHistoryResponse.type,
    sagaGuard(sendB2BEstimateToClientHistoryResponse),
  );
  yield takeLatest(actions.updateB2BCounterParties.type, sagaGuard(updateB2BCounterParties));
  yield takeLatest(actions.fetchB2BReferencesPriceResponseSaga.type, sagaGuard(fetchB2BReferencesPriceResponseSaga));
  yield takeLatest(actions.fetchB2BReferencesStockResponseSaga.type, sagaGuard(fetchB2BReferencesStockResponseSaga));

  yield takeLatest(
    actions.fetchB2BReferencesDiscountsResponseSaga.type,
    sagaGuard(fetchB2BReferencesDiscountsResponseSaga),
  );
  yield takeLatest(actions.b2BReferencesDiscountsRemovedSaga.type, sagaGuard(b2BReferencesDiscountsRemovedSaga));
  yield takeLatest(actions.checkoutB2BEstimateRequest.type, sagaGuard(checkoutB2BEstimateRequest));
  yield takeLatest(actions.checkoutB2BEstimateResponse.type, sagaGuard(checkoutB2BEstimateResponse));

  yield takeLatest(actions.sendAutocompleteBundlesRequest.type, sagaGuard(sendAutocompleteBundlesRequest));
  yield takeLatest(actions.sendAutocompleteBundlesResponse.type, sagaGuard(sendAutocompleteBundlesResponse));
  yield takeEvery(actions.sendAutocompleteReferencesRequest.type, sagaGuard(sendAutocompleteReferencesRequest));
  yield takeEvery(actions.sendAutocompleteReferencesResponse.type, sagaGuard(sendAutocompleteReferencesResponse));
}
